import { Button } from '@breetometer/components';
import { Amount, CurrencyBalance, TransactionDetails } from 'BreetComponents';

import type { IFiatTransactionDetailsViewProps } from './FiatTransactionDetails.helpers';

const FiatTransactionDetailsView = ({
	amount,
	expectedFiat,
	handleVerification,
	symbol,
	balance,
	isLoading,
	rate,
	btnTitle = 'Withdraw',
}: IFiatTransactionDetailsViewProps) => (
	<div className='transaction-details payment-request-form_usdDestination'>
		<TransactionDetails.Content>
			<TransactionDetails.Row
				label='Amount'
				value={
					<>
						{symbol}
						<Amount>{amount}</Amount>
					</>
				}
			/>

			<TransactionDetails.Row
				label='Current Rate'
				value={<Amount>{rate}</Amount>}
			/>

			<TransactionDetails.Row
				label={`Expected ${expectedFiat.currencyCode} Equivalent`}
				value={<Amount>{expectedFiat.amount}</Amount>}
			/>
		</TransactionDetails.Content>

		<CurrencyBalance
			currency={balance.currencyCode}
			balance={balance.amount}
			className='currency-balance-fluid'
			isSelected
			componentType='balance'
		/>

		<div className='new-btn-cta'>
			<Button
				label={btnTitle}
				className='right-sheet_cta_fullwidth primary-hover'
				type='button'
				onClick={handleVerification}
				isLoading={isLoading}
			/>
		</div>
	</div>
);

export default FiatTransactionDetailsView;
